import { Component } from 'react';
import { connect } from 'react-redux';
import Icon from './iconPicker/Icon';
import * as IconsActions from 'ContentData/actions/Icons';
import { makeGetIconData } from 'ContentData/selectors/Icons';
import { DEFAULT_ICON_SET } from 'ContentUtils/constants/IconSets';
import { getIconNameForLookup } from './iconPicker/IconHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_SIZE = {
  regular: 14,
  large: 20
};
function makeMapStateToProps() {
  const getIconData = makeGetIconData();
  return function mapStateToProps(state) {
    return getIconData(state);
  };
}
const mapDispatchToProps = {
  fetchIcon: IconsActions.fetchIcon
};
const connector = connect(makeMapStateToProps, mapDispatchToProps);
class FieldLabelIcon extends Component {
  componentDidMount() {
    const {
      fetchIcon,
      icon
    } = this.props;
    if (!this.fontAwesomeIcon) {
      const iconSet = icon.set || DEFAULT_ICON_SET;
      fetchIcon(iconSet, {
        search: icon.name
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }
  get fontAwesomeIcon() {
    const {
      icon,
      selectedIcons = {}
    } = this.props;
    if (!icon) return;
    const {
      name,
      type
    } = icon;
    const iconName = type ? `${getIconNameForLookup(name)}:${type}` : name;
    return selectedIcons[iconName];
  }
  render() {
    const {
      icon,
      largerIcon
    } = this.props;
    if (!icon || !this.fontAwesomeIcon) return null;
    const {
      name,
      viewPort,
      svg
    } = this.fontAwesomeIcon;
    const iconData = {
      name,
      viewPort,
      svg
    };
    const iconSize = largerIcon ? ICON_SIZE.large : ICON_SIZE.regular;
    return /*#__PURE__*/_jsx(Icon, {
      iconData: iconData,
      height: iconSize,
      marginInlineEnd: "200",
      width: iconSize
    });
  }
}
export default connect(makeMapStateToProps, mapDispatchToProps)(FieldLabelIcon);